import { render, staticRenderFns } from "./OnboardingCoordinator.vue?vue&type=template&id=7f9a4ff6&scoped=true"
import script from "./OnboardingCoordinator.vue?vue&type=script&lang=js"
export * from "./OnboardingCoordinator.vue?vue&type=script&lang=js"
import style0 from "./OnboardingCoordinator.vue?vue&type=style&index=0&id=7f9a4ff6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f9a4ff6",
  null
  
)

export default component.exports